import './CreateDialogTransportEntities.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import useAxiosHook from '../../../../../hooks/useAxiosHook';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import useToastMessage from '../../../../../hooks/useToastMessage';
import { sequential } from '../../../../../utils/helpers/functions';
import { TransportEntitiesType } from '../../TransportEntities.functions';
import FormContainer from './FormContainer';

type Props = {
  isShown: boolean;
  data: TransportEntitiesType | undefined;
  isEditDialog: boolean;
  onHide: () => void;
  reloadCollection: () => void;
};

function CreateDialog({
  isShown,
  data,
  isEditDialog,
  onHide,
  reloadCollection,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const isOnMobile = useMediaQuery('(max-width: 768px)');

  const {
    data: createData,
    error: createError,
    isLoading: isCreateLoading,
    reload: createReload,
  } = useAxiosHook(
    {
      url: '/v2/transport-entities',
      method: 'POST',
    },
    {
      skipWhen: true,
    }
  );
  const {
    data: editData,
    error: editError,
    isLoading: isEditLoading,
    reload: editReload,
  } = useAxiosHook(
    {
      url: `/v2/transport-entities/${data?.id}`,
      method: 'PUT',
    },
    {
      skipWhen: true,
    }
  );

  useToastMessage(createData, createError, {
    success: {
      summary: t('The transport entity has been created successfully.'),
      callback: () => sequential(onHide, reloadCollection),
    },
    error: {
      summary: t('An error occurred while creating the transport entity.'),
      callback: () => {
        console.error('createError ', createError);
        if (createError?.response?.status === 409) {
          return t('The transport entity already exists.');
        }
        return t('An error occurred while creating the transport entity.');
      },
    },
  });

  useToastMessage(editData, editError, {
    success: {
      summary: t('The transport entity has been updated successfully.'),
      callback: () => sequential(onHide, reloadCollection),
    },
    error: {
      summary: t('An error occurred while updating the transport entity.'),
      callback: () => {
        console.error('editError ', editError);
        if (editError?.response?.status === 409) {
          return t('The transport entity already exists.');
        }
        return t('An error occurred while updating the transport entity.');
      },
    },
  });

  const dialogFooter = (
    <>
      <Button
        type="button"
        label={t('Cancel')}
        className="p-button-text"
        onClick={() => onHide()}
      />
      <Button
        type="submit"
        form="transport-entity-create-edit-form"
        label={
          isEditLoading || isCreateLoading
            ? t('Saving...')
            : isEditDialog
            ? t('Save changes')
            : t('Add transport entity')
        }
        disabled={isEditLoading || isCreateLoading}
      />
    </>
  );

  function handleCreation(data: TransportEntitiesType) {
    createReload({ data });
  }

  function handleEditing(data: TransportEntitiesType) {
    editReload({ data });
  }

  return (
    <Dialog
      header={
        isEditDialog ? t('Edit transport entity') : t('Create transport entity')
      }
      footer={dialogFooter}
      visible={isShown}
      resizable={false}
      onHide={onHide}
      maximizable
      maximized={isOnMobile}
      style={{ width: 680, maxWidth: '100%' }}
      className="create-transport-entities-page-dialog"
    >
      {/* {isEditLoading || isCreateLoading ? (
        <DialogSpinner />
      ) : ( */}
      <FormContainer
        isEditDialog={isEditDialog}
        transportEntityData={data}
        handleCreation={handleCreation}
        handleEditing={handleEditing}
      />
      {/* )} */}
    </Dialog>
  );
}

export default CreateDialog;
